import React, { FC, ReactElement, useContext } from 'react'
import IconButton, { IconButtonType } from '../../Common/Components/IconButton'
import { IconName } from '../../Common/Components/Icon'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { LanguageContext, PromptContext } from '../../Common/Contexts'
import { UsersByExtension } from '../../../../i18n'
import { PromptDisplayType } from '../../Common/Contexts/PromptContext'
import { LanguageUtils } from '../../Common/Utils/LanguageUtils'
import { TelSysTypes } from '../../../NonReact/constants/TelephonyServerTypes'
import { CrmIntegrationLicence } from '../../../NonReact/common/Types/SelfProvisioning/SelfProvisioningTypes'

type Props = {
    provisionAllUsers: () => Promise<void>
    telSysType?: TelSysTypes
    crmIntegrationLicenseType: CrmIntegrationLicence
}

export const ProvisionAllCrm: FC<Props> = ({
    provisionAllUsers,
    telSysType,
    crmIntegrationLicenseType
}: Props): ReactElement => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler

    const { displayPromptPromise }: PromptDisplayType = useContext(PromptContext)

    const clickHandler: () => Promise<void> = async (): Promise<void> => {
        await displayPromptPromise(
            LanguageUtils.formatLanguageEntry(
                language.getInterpolated(
                    UsersByExtension.ProvisionAllCrm_PromptMessage,
                    language.getWithMSTCheck(`UsersByExtension_CrmLicenceType_${crmIntegrationLicenseType}`, telSysType)
                )
            ),
            language.get(UsersByExtension.AddAllUsers_Confirm),
            language.get(UsersByExtension.AddAllUsers_Cancel)
        )

        await provisionAllUsers()
    }

    return (
        <div className='add-all-extensions'>
            <div className='add-all-icon-container'>
                <IconButton
                    type={IconButtonType.BUTTON}
                    iconName={IconName.PROVISION_ALL_CRM}
                    onClick={async (): Promise<void> => clickHandler()}
                    title={language.getInterpolated(
                        UsersByExtension.ProvisionAllCrm_Button_Title_Interpolated,
                        language.getWithMSTCheck(
                            `UsersByExtension_CrmLicenceType_${crmIntegrationLicenseType}`,
                            telSysType
                        )
                    )}
                />
            </div>
        </div>
    )
}
